import { render, staticRenderFns } from "./standardizationFiles.vue?vue&type=template&id=9683f148&scoped=true&"
import script from "./standardizationFiles.vue?vue&type=script&lang=js&"
export * from "./standardizationFiles.vue?vue&type=script&lang=js&"
import style0 from "./standardizationFiles.vue?vue&type=style&index=0&id=9683f148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9683f148",
  null
  
)

export default component.exports